import {Component, Input, Output, EventEmitter, ViewChild, OnInit, OnChanges, OnDestroy, SimpleChanges} from '@angular/core';
import {Subscription} from 'rxjs';
import {EnvService} from "../../services/env.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {AuthService} from "../../services/auth.service";
import {MicroSelectComponent} from "../../shared/select/micro-select.component";
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";

@Component({
  selector: 'micro-location-select',
  templateUrl: './location-select.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi:true,
      useExisting: LocationSelectComponent
    }
  ]
})
export class LocationSelectComponent implements OnInit, OnChanges, OnDestroy, ControlValueAccessor {
  @Input() companyId: any;
  private request?: Subscription;
  private initialized = false;

  @ViewChild("sel", {static: true}) sel:MicroSelectComponent;

  @Output()
  locationIdChange:EventEmitter<any> = new EventEmitter<any>();

  @Input()
  locationId:any = '';

  @Output()
  valueChange:EventEmitter<any> = new EventEmitter<any>();

  @Input()
  value:any = '';

  @Input()
  required:boolean = false;

  @Input()
  disabled:boolean = false;

  options:any[];

  onChange = (locationId) => {};
  onTouched = () => {};
  touched = false;

  change(e) {
    this.onChange(e);
    this.locationIdChange.emit(e);
    this.valueChange.emit(this.sel.getSelectedValue());
  }

  constructor(private auth:AuthService, private env:EnvService, private http:HttpClient) {
  }

  registerOnChange(onChange: any): void {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any): void {
    this.onTouched = onTouched;
  }

  writeValue(locationId: string): void {
    this.locationId = locationId;
  }

  reload() {
    this.request?.unsubscribe();
    this.options = [];
    let params = new HttpParams();
    if (this.companyId) {
      params = params.set('companyId', this.companyId);
    }
    this.sel.loading = true;
    return this.request = this.http.get(`${this.env.e.url}/domain/locations/all`, {params})
      .subscribe({
        next: data => {
          this.options = data as any[];
          this.sel.loading = false;
        },
        error: () => this.sel.loading = false
      });
  }

  ngOnInit(): void {
    this.initialized = true;
    this.reload();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.initialized && changes.companyId) {
      this.reload();
    }
  }

  ngOnDestroy(): void {
    this.request?.unsubscribe();
  }
}
